<template>
  <Modal :big="true" v-if="eligibilityOfChargeModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100">
        <div></div>
        <h3 class="section-header fw-bold">Eligibility of Charges</h3>
        <button class="btn btn-gray btn-xl" @click="eligibilityOfChargeModal = false">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <div class="d-flex flex-column align-items-center">
        <!-- <h4 class="fw-bold fs-3">Charge-Based Limitations</h4> -->
        <table
          class="border w-100 mb-5 fs-5"
          v-if="charges.filter((chg) => chg.ProbationLimitation !== 0 && chg.ChargeStatus == 0).length > 0"
        >
          <thead>
            <th class="pl-5">Count #</th>
            <th>Section</th>
            <th>Description</th>
            <th>Eligibility</th>
            <!-- <th>Pled</th> -->
            <th>Limitation</th>
            <th>Authority</th>
          </thead>
          <tbody>
            <tr
              v-for="charge in charges.filter((chg) => chg.ProbationLimitation !== 0 && chg.ChargeStatus == 0)"
              :key="charge.Id"
            >
              <td class="pl-5">{{ charge.CountNumber }}</td>
              <td>
                {{ charge.SectionNumber }}
              </td>
              <td>{{ charge.Name }}</td>
              <td>
                {{ ["Eligible", "Ineligible", "Unusual", "Unusual & Sex A", "Sex A", "Sex B"][charge.ProbationLimitation] }}
              </td>
              <!-- <td>
                {{
                  charges.findIndex(
                    (chg) =>
                      chg.CrimeTypeId == 3 &&
                      chg.ProbationLimitationId ==
                        ProbationLimitations.findIndex(
                          (pl) => pl.Id == charge.ProbationLimitationId
                        )
                  ) !== -1
                    ? "Yes"
                    : "No"
                }}
              </td> -->
              <td>
                {{ ProbationLimitations.find((pl) => pl.Id == charge.ProbationLimitationId)?.LegacyStatuteText }}
              </td>

              <td class="">
                <button
                  class="btn btn-primary-outline btn-xl"
                  @click="emitLawText(ProbationLimitations.find((pl) => pl.Id == charge.ProbationLimitationId))"
                >
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <h5 class="fs-5 my-5" v-else>None of the charges in this case are statutorily ineligible for probation</h5>
      </div>
    </template>
  </Modal>
  <Modal v-if="showFactorModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100">
        <div></div>
        <h3 class="section-header fw-bold">Findings</h3>
        <button class="btn btn-gray btn-xl" @click="showFactorModal = false">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <div class="col-12 p-0" style="width: 70vw">
        <div class="d-flex flex-column">
          <!-- <h3 class="fs-3  fw-bold mb-5">
            <span v-if="selectedProbationFactorCategory == 'General'">California Rules of Court 4.414<span
                v-if="selectedProbationFactorSubcategory == 'Crime'">(a)</span><span v-else>(b)</span></span>
            <span v-if="selectedProbationFactorCategory == 'Unusual'">California Rules of Court 4.413(c)</span>
            <span v-if="selectedProbationFactorCategory == 'Sex A'">PC 1203.067(a)</span>
            <span v-if="selectedProbationFactorCategory == 'Sex B'">PC 1203.066(d)</span>
          </h3> -->
          <!-- <p class="fs-5 my-3">Findings selected as "True" will appear in Probation Findings Checklist reports</p> -->
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex">
              <div
                class="tab"
                @click="
                  selectedProbationFactorCategory = 'General';
                  selectedProbationFactorSubcategory = 'Crime';
                "
                :class="
                  selectedProbationFactorCategory == 'General' && selectedProbationFactorSubcategory == 'Crime'
                    ? 'tab-active'
                    : 'tab-inactive'
                "
              >
                Rule 4.414(a) (Crime)
              </div>
              <div
                class="tab"
                @click="
                  selectedProbationFactorCategory = 'General';
                  selectedProbationFactorSubcategory = 'Defendant';
                "
                :class="
                  selectedProbationFactorCategory == 'General' && selectedProbationFactorSubcategory == 'Defendant'
                    ? 'tab-active'
                    : 'tab-inactive'
                "
              >
                Rule 4.414(b) (Defendant)
              </div>
              <div
                class="tab"
                v-if="probationEligibility.Unusual"
                @click="selectedProbationFactorCategory = 'Unusual'"
                :class="selectedProbationFactorCategory == 'Unusual' ? 'tab-active' : 'tab-inactive'"
              >
                Rule 4.413(c) (Unusual)
              </div>
              <div
                class="tab"
                v-if="probationEligibility.SpecialA"
                @click="selectedProbationFactorCategory = 'Sex A'"
                :class="selectedProbationFactorCategory == 'Sex A' ? 'tab-active' : 'tab-inactive'"
              >
                PC 1203.067 (Sex A)
              </div>
              <div
                class="tab"
                v-if="probationEligibility.SpecialB"
                @click="selectedProbationFactorCategory = 'Sex B'"
                :class="selectedProbationFactorCategory == 'Sex B' ? 'tab-active' : 'tab-inactive'"
              >
                PC 1203.066 (Sex B)
              </div>
            </div>

            <div></div>
          </div>

          <table class="w-100 border fs-5">
            <thead>
              <th class="ta-c">True</th>
              <th>Description</th>
              <th>Authority</th>
            </thead>
            <tbody>
              <tr class="selectable" v-for="pf in filteredProbationFactors" :key="pf.Id">
                <td class="ta-c">
                  <input
                    type="checkbox"
                    :id="pf.StatuteNumber"
                    @input="handleProbationFactorSelect(pf)"
                    :checked="probationFactorInCaseProbationFactors(pf)"
                  />
                </td>
                <td>
                  <label class="pb-0 mb-0 clickable" :for="pf.StatuteNumber">{{ pf.Name }}</label>
                </td>
                <td>
                  <button class="btn btn-primary-outline btn-xl" @click="emitLawTextFactor(pf)">View</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </Modal>
  <Modal v-if="showDeleteLimitationModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100">
        <div></div>
        <h3 class="fs-3 fw-bold">Delete Non-Charge Limitation</h3>
        <button class="btn btn-gray btn-xl" @click="showDeleteLimitationModal = false">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <div class="d-flex flex-column align-items-center col-12">
        <p class="fs-5">Are you sure you want to delete the following Limitation?</p>
        <p class="fs-5 my-5">
          {{ selectedCaseLimitation.LegacyStatuteText }}:
          {{ selectedCaseLimitation.Name }}
        </p>
        <div>
          <button
            class="btn btn-xl btn-primary"
            @click="
              deleteCaseProbationLimitation(selectedCaseLimitation);
              show;
            "
          >
            Delete
          </button>
        </div>
      </div>
    </template>
  </Modal>

  <Modal :big="true" v-if="showAddLimitationModal">
    <template v-slot:header>
      <div class="d-flex justify-content-between w-100">
        <div></div>
        <h3 class="section-header fw-bold">Add Limitation</h3>
        <button class="btn btn-gray btn-xl" @click="showAddLimitationModal = false">
          <i class="fa fa-close"></i>
        </button>
      </div>
    </template>
    <template v-slot:body>
      <Modal v-if="showAddSelectedLimitationModal">
        <template v-slot:header>
          <div class="d-flex justify-content-between w-100">
            <div></div>
            <h3 class="fs-3 fw-bold">Add Limitation to Selections</h3>
            <button class="btn btn-gray btn-xl" @click="showAddSelectedLimitationModal = false">
              <i class="fa fa-close"></i>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <div class="d-flex flex-column align-items-center col-12">
            <p class="fs-5">
              Add the following Limitation to selections? Limitations you add here will show up on the Probation summary page
              and Probation reports.
            </p>
            <p class="fs-5 my-5">
              {{ selectedCaseLimitation.LegacyStatuteText }}:
              {{ selectedCaseLimitation.Name }}
            </p>
            <div>
              <button class="btn btn-xl btn-primary" @click="createCaseProbationLimitation(selectedCaseLimitation)">
                Add Limitation
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <div class="d-flex flex-column col-12">
        <div class="d-flex">
          <button
            class="tab"
            v-for="category in categories.filter((cat) => cat !== 'FACTOR')"
            :key="cateory"
            @click="selectedCategory = category"
            :class="selectedCategory === category ? 'tab-active' : 'tab-inactive'"
          >
            {{ upperCaseToOnlyFirstLetter(category) }}
          </button>
          <button
            class="tab border-right"
            @click="selectedCategory = null"
            :class="selectedCategory === null ? 'tab-active' : 'tab-inactive'"
          >
            Miscellaneous
          </button>
        </div>
        <table class="border-left border-right border-top border-bottom fs-5">
          <thead class="">
            <th class="fs-5 w-50 pl-5">Description</th>
            <th class="fs-5 text-center">Requires Pleading</th>
            <th class="fs-5">Eligibility</th>
            <th class="fs-5">Authority</th>
            <th></th>
          </thead>
          <tbody>
            <tr class="selectable clickable" v-for="limitation in filteredLimitations" :key="limitation.Id">
              <td class="pl-5">{{ limitation.Name }}</td>
              <td class="text-center">{{ limitation.Pleadable ? "Yes" : "No" }}</td>
              <td>
                {{ ["Eligible", "Ineligible", "Unusual", "Unusual & Sex A", "Sex A", "Sex B"][limitation.Eligibility] }}
              </td>
              <td>
                <button class="btn btn-primary-outline btn-xl w-100" @click="emitLawText(limitation)">
                  {{ limitation.LegacyStatuteText }}
                </button>
              </td>
              <td>
                <button
                  class="btn btn-primary btn-xl"
                  @click="
                    selectedCaseLimitation = limitation;
                    showAddSelectedLimitationModal = true;
                  "
                >
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </Modal>

  <div class="col-12 d-flex justify-content-center px-0 main">
    <div class="card col-12 p-0" v-if="!loading">
      <div class="card-body d-flex flex-column fs-5 overflow-auto scroller scrollable scrollbar" style="max-height: 65vh">
        <div class="d-flex w-100 justify-content-evenly">
          <div class="d-flex flex-column w-100">
            <h1 class="section-header fw-bold pl-5 mb-3">Probation Eligibility</h1>
            <h3 class="fs-3 fw-bold mb-3 pl-5" v-if="probationEligibility.Eligible">
              Defendant is Eligible for Probation
              <span v-if="probationEligibility.Unusual || probationEligibility.SpecialA || probationEligibility.SpecialB"
                >with Findings</span
              >
            </h3>
            <h3 class="fs-3 fw-bold pl-5" v-else>Defendant is Ineligible for Probation</h3>
            <ul class="pl-5 list-style-none">
              <li v-if="probationEligibility.InelFromLimitations" class="fs-5 mb-3">
                This case contains probation limitations that render the defendant statutorily ineligible for probation
              </li>
              <li v-if="probationEligibility.InelFromStrikes" class="fs-5 mb-3">
                This case contains a felony charge and has one or more prior strikes alleged
              </li>
              <li v-if="probationEligibility.InelFromCharges" class="fs-5 mb-3">
                One or more charges render the defendant statutorily ineligible for probation
              </li>
            </ul>

            <div class="d-flex flex-column" v-if="probationEligibility.Eligible">
              <p class="pl-5 mb-3" v-if="probationEligibility.Eligible">
                In order for probation to be granted,
                <strong class="fw-bold">ALL</strong> of the following
                <strong class="fw-bold">MUST</strong>
                occur:
              </p>
              <div v-if="probationEligibility.Eligible">
                <table class="border-bottom border-right">
                  <tr class=" " v-if="probationEligibility.Eligible && probationEligibility.SpecialB">
                    <td class="pl-5">
                      The Court must make findings regarding the offense and the defendant's relationship to the victim per
                      PC 1203.066
                    </td>
                    <td>Sex B</td>
                    <td style="text-align: right">
                      <button
                        class="btn btn-xl btn-primary-outline"
                        style="width: 180px"
                        @click="
                          selectedProbationFactorCategory = 'Sex B';
                          showFactorModal = true;
                        "
                      >
                        Findings
                      </button>
                    </td>
                  </tr>
                  <tr class="" v-if="probationEligibility.Eligible && probationEligibility.SpecialA">
                    <td class="pl-5">The Court must make orders and findings pursuant to PC 1203.067(a)</td>
                    <td>Sex A</td>
                    <td style="text-align: right">
                      <button
                        class="btn btn-xl btn-primary-outline"
                        style="width: 180px"
                        @click="
                          selectedProbationFactorCategory = 'Sex A';
                          showFactorModal = true;
                        "
                      >
                        Findings
                      </button>
                    </td>
                  </tr>
                  <tr class="" v-if="probationEligibility.Eligible && probationEligibility.Unusual">
                    <td class="pl-5">
                      The Court must make a finding that this is an "unusual" case as defined in California Rules of Court
                      4.413(c)
                    </td>
                    <td>Unusual</td>
                    <td style="text-align: right">
                      <button
                        class="btn btn-xl btn-primary-outline"
                        style="width: 180px"
                        @click="
                          selectedProbationFactorCategory = 'Unusual';
                          showFactorModal = true;
                        "
                      >
                        Findings
                      </button>
                    </td>
                  </tr>
                  <tr class="">
                    <td class="pl-5">General findings per California Rules of Court 4.414 must be considered</td>
                    <td>General</td>
                    <td style="text-align: right">
                      <button
                        class="btn btn-xl btn-primary-outline"
                        style="width: 180px"
                        @click="
                          selectedProbationFactorCategory = 'General';
                          selectedProbationFactorSubcategory = 'Crime';
                          showFactorModal = true;
                        "
                      >
                        Findings
                      </button>
                    </td>
                  </tr>
                </table>
              </div>
              <p class="mt-3 pl-5" v-else>This case is statutorily ineligible for probation</p>

              <div
                v-if="charges.filter((chg) => chg.ProbationLimitation !== 0 && chg.ChargeStatus == 0).length > 0"
                class="w-100 d-flex flex-column mt-5"
              >
                <h3 class="fs-3 fw-bold pl-5">Charge-based Limitations</h3>
                <div>
                  <table
                    class="border-top border-bottom border-right mb-5 fs-5"
                    v-if="charges.filter((chg) => chg.ProbationLimitation !== 0 && chg.ChargeStatus == 0).length > 0"
                  >
                    <thead>
                      <th class="pl-5">Count #</th>
                      <th>Section</th>
                      <th>Description</th>
                      <th>Eligibility</th>
                      <!-- <th>Pled</th> -->
                      <th>Limitation</th>
                      <th>Authority</th>
                    </thead>
                    <tbody>
                      <tr
                        v-for="charge in charges.filter((chg) => chg.ProbationLimitation !== 0 && chg.ChargeStatus == 0)"
                        :key="charge.Id"
                      >
                        <td class="pl-5">{{ charge.CountNumber }}</td>
                        <td>
                          {{ charge.SectionNumber }}
                        </td>

                        <td>
                          <span v-if="chg?.CrimeState == 'Attempt' || chg?.Attributes?.severityTypePicked == 'Attempt'"
                            >Attempted</span
                          >
                          <span v-if="chg?.CrimeState == 'Conspiracy' || chg?.Attributes?.severityTypePicked == 'Conspiracy'"
                            >Conspiracy to Commit</span
                          >
                          {{ charge.Name }}
                        </td>
                        <td>
                          {{
                            ["Eligible", "Ineligible", "Unusual", "Unusual & Sex A", "Sex A", "Sex B"][
                              charge.ProbationLimitation
                            ]
                          }}
                        </td>
                        <!-- <td>
                    {{
                      charges.findIndex(
                        (chg) =>
                          chg.CrimeTypeId == 3 &&
                          chg.ProbationLimitationId ==
                            ProbationLimitations.findIndex(
                              (pl) => pl.Id == charge.ProbationLimitationId
                            )
                      ) !== -1
                        ? "Yes"
                        : "No"
                    }}
                  </td> -->
                        <td>
                          {{ ProbationLimitations.find((pl) => pl.Id == charge.ProbationLimitationId)?.LegacyStatuteText }}
                        </td>

                        <td>
                          <button
                            class="btn btn-primary-outline btn-xl"
                            @click="emitLawText(ProbationLimitations.find((pl) => pl.Id == charge.ProbationLimitationId))"
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <ul class="mb-5 pl-0 ml-0" v-if="probationEligibility.Eligible">
                <li>
                  General findings per California Rules of Court 4.414 must be considered
                </li>
                <li v-if="probationEligibility.Unusual">
                  The court must make a finding that this is an "unusual" case as defined
                  in California Rules of Court 4.413(c)
                </li>
                <li v-if="probationEligibility.SpecialA">
                  The court must order a 90 day custodial observation, conduct a
                  psychological evaluation, and make findings per PC 1203.067
                </li>
                <li v-if="probationEligibility.SpecialB">
                  The court must make findings regarding the offense and the defendant's
                  relationship to the victim per PC 1203.066
                </li>
              </ul> -->
            </div>
            <!-- <table
              class="border"
              style="max-width: 100%"
              v-if="probationEligibility.Eligible"
            >
              <thead>
                <th class="p-3 ta-c" v-if="probationEligibility.Eligible">
                  General (Crime)
                </th>
                <th class="p-3 ta-c" v-if="probationEligibility.Eligible">
                  General (Defendant)
                </th>
                <th class="p-3 ta-c">Unusual Case</th>
                <th class="p-3 ta-c">Sex Findings A</th>
                <th class="p-3 ta-c">Sex Findings B</th>
              </thead>
              <tbody>
                <tr>
                  <td class="p-3 ta-c" v-if="probationEligibility.Eligible">
                    <button
                      class="btn btn-xl btn-primary"
                      style="width: 180px"
                      @click="
                        selectedProbationFactorCategory = 'General';
                        selectedProbationFactorSubcategory = 'Crime';
                        showFactorModal = true;
                      "
                    >
                      Rule 4.414(a)
                    </button>
                  </td>
                  <td class="p-3 ta-c" v-if="probationEligibility.Eligible">
                    <button
                      class="btn btn-xl btn-primary"
                      style="width: 180px"
                      @click="
                        selectedProbationFactorCategory = 'General';
                        selectedProbationFactorSubcategory = 'Defendant';
                        showFactorModal = true;
                      "
                    >
                      Rule 4.414(b)
                    </button>
                  </td>
                  <td class="p-3 ta-c">
                    <button
                      class="btn btn-xl btn-primary"
                      style="width: 180px"
                      v-if="probationEligibility.Eligible && probationEligibility.Unusual"
                      @click="
                        selectedProbationFactorCategory = 'Unusual';
                        showFactorModal = true;
                      "
                    >
                      Rule 4.413(c)
                    </button>
                    <button class="btn btn-xl btn-disabled" disabled v-else>
                      Rule 4.413(c)
                    </button>
                  </td>
                  <td class="p-3 ta-c">
                    <button
                      class="btn btn-xl btn-primary"
                      style="width: 180px"
                      v-if="
                        probationEligibility.Eligible && probationEligibility.SpecialA
                      "
                      @click="
                        selectedProbationFactorCategory = 'Sex A';
                        showFactorModal = true;
                      "
                    >
                      PC 1203.067(a)
                    </button>
                    <button class="btn btn-xl btn-disabled" disabled v-else>
                      PC 1203.067(a)
                    </button>
                  </td>
                  <td class="p-3 ta-c">
                    <button
                      class="btn btn-xl btn-primary"
                      style="width: 180px"
                      v-if="
                        probationEligibility.Eligible && probationEligibility.SpecialB
                      "
                      @click="
                        selectedProbationFactorCategory = 'Sex B';
                        showFactorModal = true;
                      "
                    >
                      PC 1203.066
                    </button>
                    <button class="btn btn-xl btn-disabled" disabled v-else>
                      PC 1203.066
                    </button>
                  </td>
                </tr>
              </tbody>
            </table> -->
          </div>
        </div>

        <h4 class="fs-3 fw-bold pl-5 mt-5">Statutory Limitations</h4>

        <div class="w-100">
          <table class="w-100 border-top mb-5" v-if="caseProbationLimitationsPopulated.length > 0">
            <thead>
              <th class="pl-5">Section</th>
              <th class="">Description</th>
              <th class="">Eligibility</th>
              <th class="">Pleading Required</th>
              <th class="">Authority</th>
              <th></th>
            </thead>
            <tbody>
              <tr
                v-for="limitation in caseProbationLimitationsPopulated.sort((a, b) => {
                  if (a.Eligibility == 1 && b.Eligibility != 1) {
                    return -1;
                  } else if (a.Eligibility != 1 && b.Eligibility == 1) {
                    return 1;
                  } else {
                    if (a.Eligibility > 0 && b.Eligibility == 0) {
                      return a.Eligibility - b.Eligibility;
                    } else if (a.Eligibility == 0 && b.Eligibility > 0) {
                      return b.Eligibility - a.Eligibility;
                    } else {
                      return 0;
                    }
                  }
                })"
                class="border-bottom"
                :key="limitation.Id"
              >
                <td class="pl-5">{{ limitation.LegacyStatuteText }}</td>
                <td class="">{{ limitation.Name }}</td>
                <td class="">
                  {{ ["Eligible", "Ineligible", "Unusual", "Unusual & Sex A", "Sex A", "Sex B"][limitation.Eligibility] }}
                </td>
                <td class="">
                  <span v-if="!limitation.Pleadable">No</span>

                  <button
                    class="btn btn-primary btn-xl"
                    v-else-if="limitationIdsToAddAsCharges.includes(limitation.Id)"
                    @click="addToCharges(limitation)"
                  >
                    <i class="fa fa-plus"></i> Add to Charges
                  </button>
                  <span v-else>Yes</span>
                </td>
                <td class="">
                  <button class="btn btn-primary-outline btn-xl" @click="emitLawText(limitation)">View</button>
                </td>
                <td class="">
                  <button
                    class="btn btn-outline btn-xl"
                    @click="
                      selectedCaseLimitation = limitation;
                      showDeleteLimitationModal = true;
                    "
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <h5 class="fs-5 pl-5" v-else-if="probationEligibility.Eligible">
            No probation limitations have been added to this case
          </h5>
        </div>
      </div>
      <div class="card-body">
        <div class="d-flex pl-5 flex-wrap mt-5">
          <button class="btn-primary btn btn-xl" @click="showAddLimitationModal = !showAddLimitationModal">
            <!-- <i class="fa fa-plus"></i>  -->
            Add Limitations
          </button>
          <button class="btn btn-primary btn-xl mx-3" @click="eligibilityOfChargeModal = true">Charge Eligibility</button>
          <button class="btn btn-xl btn-primary" @click="generateProbationReport">Generate Report</button>
          <!-- <button class="btn btn-primary btn-xl" @click="showFactorModal = true">
            <i class="fa fa-check"></i> Findings
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Modal from "../../../components/utils/Modal.vue";
import { indexOf } from "lodash";

export default {
  name: "NewProbation",
  props: [
    "charges",
    "selectedCase",
    "ProbationLimitations",
    "caseProbationLimitations",
    "probationFactors",
    "caseProbationFactors",
  ],
  components: { Modal },
  data() {
    return {
      loading: false,
      chargeLimitations: [],
      // caseProbationLimitations: [],
      categories: [],
      selectedCategory: "PRIOR",
      showAddLimitationModal: false,
      selectedCaseLimitation: null,
      showDeleteLimitationModal: false,
      showAddSelectedLimitationModal: false,
      selectedProbationFactorCategory: "General",
      selectedProbationFactorSubcategory: "Crime",
      showFactorModal: false,
      eligibilityOfChargeModal: false,
      // probationFactors: [],
      // caseProbationFactors: [],
      // Your data properties go here
    };
  },
  computed: {
    // Your computed properties go here
    addableLimitations() {
      return this.ProbationLimitations.filter((pl) => !this.caseProbationLimitationIds.includes(pl.Id));
    },
    selectedLimitations() {
      return this.ProbationLimitations.filter((limitation) => limitation.true || limitation.pled);
    },
    caseProbationLimitationsPopulated() {
      return this.ProbationLimitations.filter((pl) => this.caseProbationLimitationIds.includes(pl.Id));
    },
    caseProbationLimitationIds() {
      const caseProbLimitIds = this.caseProbationLimitations.map((cpl) => cpl.ProbationLimitationId);
      return Array.from(new Set(caseProbLimitIds));
    },
    chargeProbationLimitationIds() {
      return this.charges.filter((chg) => chg.CrimeTypeId == 3).map((chg) => chg.ProbationLimitationId);
    },
    filteredLimitations() {
      return this.addableLimitations.filter(
        (limitation) =>
          (this.selectedCategory !== null && limitation.Category?.includes(this.selectedCategory)) ||
          (this.selectedCategory == null && limitation.Category == null)
      );
    },
    limitationIdsToAddAsCharges() {
      return this.ProbationLimitations.filter(
        (limitation) =>
          !this.chargeProbationLimitationIds.includes(limitation.Id) &&
          limitation.Pleadable &&
          this.caseProbationLimitationIds.includes(limitation.Id)
      ).map((limitation) => limitation.Id);
    },
    probationEligibility() {
      let probationEligibilityObject = {
        Eligible: true,
        Unusual: false,
        SpecialA: false,
        SpecialB: false,
        InelFromCharges: false,
        InelFromLimitations: false,
        InelFromStrikes: false,
      };
      this.caseProbationLimitations.forEach((cpl) => {
        let pl = this.ProbationLimitations.find((pl) => pl.Id == cpl.ProbationLimitationId);
        if (pl?.Eligibility == 1) {
          probationEligibilityObject.Eligible = false;
          probationEligibilityObject.InelFromLimitations = true;
        } else if (pl?.Eligibility == 2 || pl?.Eligibility == 3) {
          probationEligibilityObject.Unusual = true;
        } else if (pl?.Eligibility == 3 || pl?.Eligibility == 4) {
          probationEligibilityObject.SpecialA = true;
        } else if (pl?.Eligibility == 5) {
          probationEligibilityObject.SpecialB = true;
        }
      });
      let felony = false;
      let strikes = false;
      this.charges.forEach((chg) => {
        if (chg?.CrimeSeverityId == 3 && chg?.ChargeStatus == 0) {
          felony = true;
        }
        if (chg?.NumberOfStrikes != "0" && chg?.NumberOfStrikes != null && chg?.ChargeStatus == 0) {
          strikes = true;
        }
      });
      this.charges
        .filter((chg) => {
          return (
            chg?.ProbationLimitationId !== null &&
            chg?.ProbationLimitation !== 0 &&
            chg?.ChargeStatus == 0 &&
            (chg?.CrimeState == "Completed" || chg?.Attributes?.severityTypePicked == "Completed")
          );
        })
        .forEach((chg) => {
          if (chg?.ProbationLimitation == 1) {
            probationEligibilityObject.Eligible = false;
            probationEligibilityObject.InelFromCharges = true;
          }
          if (chg?.ProbationLimitation == 2 || chg?.ProbationLimitation == 3) {
            probationEligibilityObject.Unusual = true;
          }
          if (chg?.ProbationLimitation == 3 || chg?.ProbationLimitation == 4 || chg?.ProbationLimitation == 5) {
            probationEligibilityObject.SpecialA = true;
          }
          if (chg?.ProbationLimitation == 5) {
            probationEligibilityObject.SpecialB = true;
          }
        });
      if (felony && strikes) {
        probationEligibilityObject.InelFromStrikes = true;
        probationEligibilityObject.Eligible = false;
      }
      return probationEligibilityObject;
    },
    suggestedProbationLimitationsToAdd() {
      const chargeProbationLimitationIds = this.charges
        .filter((chg) => {
          const activeCaseProbationLimitationIds = this.caseProbationLimitations
            .filter((cpl) => cpl.IsTrue || cpl.IsPled)
            .map((cpl) => cpl.Id);
          return chg.CrimeTypeId !== 3 && !activeCaseProbationLimitationIds.includes(chg.ProbationLimitationId);
        })
        .map((chg) => chg.ProbationLimitationId);
      return this.ProbationLimitations.filter(
        (limitation) => chargeProbationLimitationIds.includes(limitation.Id) && !limitation.pled && !limitation.true
      );
    },
    // probationFactors() {
    //   return this.ProbationLimitations.filter(
    //     (limitation) => limitation.Category === "FACTOR"
    //   );
    // },
    // unusualFactors() {
    //   return this.probationFactors.filter(
    //     (factor) =>
    //       factor.LegacyStatuteText.includes("Rule 4.413(c)(1)") ||
    //       factor.LegacyStatuteText.includes("Rule 4.413(c)(2)")
    //   );
    // },
    // sexFactors() {
    //   return this.probationFactors.filter((factor) =>
    //     factor.LegacyStatuteText.includes("1203.066(d)")
    //   );
    // },
    // crimeFactors() {
    //   return this.probationFactors.filter((factor) =>
    //     factor.LegacyStatuteText.includes("Rule 4.414(a)")
    //   );
    // },
    // defendantFactors() {
    //   return this.probationFactors.filter((factor) =>
    //     factor.LegacyStatuteText.includes("Rule 4.414(b)")
    //   );
    // },
    filteredProbationFactors() {
      return this.probationFactors?.filter((pf) => {
        if (this.selectedProbationFactorCategory == "General") {
          if (pf.StatuteNumber.includes("Rule 4.414(")) {
            if (this.selectedProbationFactorSubcategory == "Defendant") {
              return pf.StatuteNumber.includes("Rule 4.414(b)");
            } else if (this.selectedProbationFactorSubcategory == "Crime") {
              return pf.StatuteNumber.includes("Rule 4.414(a)");
            }
          }
        } else if (this.selectedProbationFactorCategory == "Unusual") {
          return pf.Category == "Unusual";
        } else if (this.selectedProbationFactorCategory == "Sex A") {
          return pf.Category == "Special A";
        } else if (this.selectedProbationFactorCategory == "Sex B") {
          return pf.Category == "Special B";
        }
        return false;
      });
    },
    caseProbationFactorIds() {
      return this.caseProbationFactors.map((cpf) => cpf.ProbationFactorId);
    },
  },
  methods: {
    generateProbationReport() {
      this.$emit("generateProbationReport");
    },
    upperCaseToOnlyFirstLetter(string) {
      if (string == "GBI") {
        return "GBI";
      }
      return string.toLowerCase().charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    },
    // Your methods go here
    async handleSelect(limitation) {
      const ready = await this.$nextTick();
      const isInCaseProbationLimitations =
        this.caseProbationLimitations.findIndex((cpl) => cpl.ProbationLimitationId === limitation.Id) !== -1;

      if (
        !isInCaseProbationLimitations &&
        !this.chargeProbationLimitationIds.includes(limitation.Id) &&
        (limitation.true || limitation.pled)
      ) {
        this.createCaseProbationLimitation(limitation);
      } else if (isInCaseProbationLimitations && !limitation.true && !limitation.pled) {
        this.deleteCaseProbationLimitation(limitation);
      } else if (isInCaseProbationLimitations) {
        this.updateCaseProbationLimitation(limitation);
      }
    },
    capitalizeFirstLetter(string) {
      return string.toLowerCase().charAt(0).toUpperCase() + string.slice(1);
    },
    async updateCaseProbationLimitation(limitation) {
      const cpl = this.caseProbationLimitations.find((cpl) => cpl.ProbationLimitationId === limitation.Id);
      if (cpl) {
        await axios.put(
          process.env.VUE_APP_ENDPOINT + `/api/caseProbationLimitationStatus/${cpl.Id}`,
          {
            IsTrue: limitation.true,
            IsPled: limitation.pled,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
          }
        );
      }
    },
    async createCaseProbationLimitation(limitation) {
      if (this.caseProbationLimitations.find((cpl) => cpl.ProbationLimitationId === limitation.Id)) {
        this.showAddSelectedLimitationModal = false;
        this.selectedCaseLimitation = false;
        return;
      }
      const createdCPL = await axios
        .post(
          process.env.VUE_APP_ENDPOINT + "/api/caseProbationLimitationStatus",
          {
            CaseId: this.selectedCase.Id,
            ProbationLimitationId: limitation.Id,
            IsTrue: true,
            // IsPled: limitation.pled,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
          }
        )
        .then((res) => {
          const cpl = res.data;
          this.caseProbationLimitations.push(cpl);
        });
      this.showAddSelectedLimitationModal = false;
      this.selectedCaseLimitation = false;
    },
    async deleteCaseProbationLimitation(limitation) {
      const cpl = this.caseProbationLimitations.find((cpl) => cpl.ProbationLimitationId === limitation.Id);
      if (cpl) {
        await axios.delete(process.env.VUE_APP_ENDPOINT + `/api/caseProbationLimitationStatus/${cpl.Id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        });
        // this.caseProbationLimitations = this.caseProbationLimitations.filter(
        //   (cpl) => cpl.Id !== cpl.Id
        // );
        const foundIndex = this.caseProbationLimitations.findIndex((casepl) => casepl.Id === cpl.Id);
        if (foundIndex > -1) {
          this.caseProbationLimitations.splice(foundIndex, 1);
        }
      }
      this.selectedCaseLimitation = null;
      this.showDeleteLimitationModal = false;
    },
    async loadCaseProbationLimitations() {
      this.caseProbationLimitations = await axios
        .get(process.env.VUE_APP_ENDPOINT + `/api/caseProbationLimitationStatus/${this.selectedCase.Id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));

      return this.caseProbationLimitations;
    },
    pleadCaseProbationLimitations() {
      const chargeProbationLimitationIds = this.charges
        .filter((chg) => chg?.CrimeTypeId == 3)
        .map((chg) => chg?.ProbationLimitationId);
      chargeProbationLimitationIds.forEach((chargeProbationLimitationId) => {
        if (chargeProbationLimitationId == null) {
          return;
        }
        const foundLimitationIndex = this.caseProbationLimitations.findIndex(
          (limitation) => limitation.Id == chargeProbationLimitationId
        );
        if (foundLimitationIndex == -1) {
          const foundProbationLimitation = this.ProbationLimitations.find(
            (limitation) => limitation.Id === chargeProbationLimitationId
          );
          foundProbationLimitation.pled = true;
          // this.createCaseProbationLimitation(foundProbationLimitation);
        }
      });
    },
    // async setCaseProbationFactor(probationFactor, bool) {
    //   console.log(probationFactor, bool);
    //   const foundCaseProbationFactorIndex = this.caseProbationFactors.findIndex(
    //     (cpf) => cpf.ProbationFactorId === probationFactor.Id
    //   );
    //   if (foundCaseProbationFactorIndex == -1) {
    //     await axios
    //       .post(
    //         process.env.VUE_APP_ENDPOINT + "/api/caseProbationFactors",
    //         {
    //           CaseId: this.selectedCase.Id,
    //           ProbationFactorId: probationFactor.Id,
    //           IsTrue: bool,
    //         },
    //         {
    //           headers: {
    //             Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    //           },
    //         }
    //       )
    //       .catch((e) => console.log(e));
    //   } else {
    //     await axios
    //       .put(
    //         process.env.VUE_APP_ENDPOINT +
    //           `/api/caseProbationFactors/${this.caseProbationFactors[foundCaseProbationFactorIndex].Id}`,
    //         {
    //           IsTrue: bool,
    //         },
    //         {
    //           headers: {
    //             Authorization: `Bearer ${localStorage.getItem("user_token")}`,
    //           },
    //         }
    //       )
    //       .catch((e) => console.log(e));
    //   }
    // },
    probationFactorInCaseProbationFactors(probationFactor) {
      return this.caseProbationFactors.find((cpf) => cpf.ProbationFactorId == probationFactor.Id);
    },
    async handleProbationFactorSelect(probationFactor) {
      const foundCaseProbationFactorIndex = this.caseProbationFactors.findIndex(
        (cpf) => cpf.ProbationFactorId === probationFactor.Id
      );

      if (foundCaseProbationFactorIndex == -1) {
        await axios
          .post(
            process.env.VUE_APP_ENDPOINT + "/api/caseProbationFactors",
            {
              CaseId: this.selectedCase.Id,
              ProbationFactorId: probationFactor.Id,
              IsTrue: true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              },
            }
          )
          .then((res) => {
            this.caseProbationFactors.push(res.data);
          })
          .catch((e) => console.log(e));
      } else {
        await axios
          .delete(
            process.env.VUE_APP_ENDPOINT +
              `/api/caseProbationFactors/${this.caseProbationFactors[foundCaseProbationFactorIndex].Id}`,

            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user_token")}`,
              },
            }
          )
          .then((res) => {
            this.caseProbationFactors[foundCaseProbationFactorIndex].IsTrue = !this.caseProbationFactors[
              foundCaseProbationFactorIndex
            ].IsTrue;
          })
          .catch((e) => console.log(e));
        this.caseProbationFactors.splice(foundCaseProbationFactorIndex, 1);
      }
    },
    // suggestProbationLimitationsToAdd(){

    //   // chargeProbationLimitationIds.forEach((chargeProbationLimitationId) => {
    //   //   if (chargeProbationLimitationId == null) {
    //   //     return;
    //   //   }
    //   //   // const foundLimitationIndex = this.caseProbationLimitations.findIndex(
    //   //   //   (limitation) => limitation.Id == chargeProbationLimitationId
    //   //   // );
    //   //   if (foundLimitationIndex == -1) {
    //   //     const foundProbationLimitation = this.ProbationLimitations.find(
    //   //       (limitation) => limitation.Id === chargeProbationLimitationId
    //   //     );
    //   //     foundProbationLimitation.pled = true;
    //   //     // this.createCaseProbationLimitation(foundProbationLimitation);
    //   //   }
    //   // });
    // },
    async addToCharges(limitation) {
      const statute = limitation.LegacyStatuteText.replaceAll("PC ", "")
        .replaceAll("VC ", "")
        .replaceAll("HS ", "")
        .replaceAll("BP ", "")
        .replaceAll("GC ", "")
        .replaceAll("PC", "")
        .replaceAll("VC", "")
        .replaceAll("HS", "")
        .replaceAll("BP", "")
        .replaceAll("GC", "");
      const crimeIdToAdd = await axios
        .get(process.env.VUE_APP_ENDPOINT + `/api/crimes/search?bDate=${moment().format('YYYY-MM-DD')}&statute=${statute}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data?.content[15]?.Id)
        .catch((e) => console.log(e));
      const chargeToAdd = {
        crimeId: crimeIdToAdd,
        currentCount: 0,
        CrimeState: "Completed",
        OffenseDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      this.$emit("addChargeFromPopup", chargeToAdd);
    },
    markProbationLimitations() {
      this.ProbationLimitations.forEach((limitation) => {
        if (this.chargeProbationLimitationIds.includes(limitation.Id) && limitation.Pleadable) {
          limitation.pled = true;
        } else if (limitation.Pleadable) {
          limitation.pled = false;
        }
        // if (this.chargeLimitations.includes(limitation.Id)) {
        //   limitation.true = true;
        // } else {
        //   limitation.true = false;
        // }
        if (this.caseProbationLimitationIds.includes(limitation.Id)) {
          const foundLimitationIndex = this.caseProbationLimitations.findIndex(
            (cpl) => cpl.ProbationLimitationId === limitation.Id
          );
          const foundLimitation = this.caseProbationLimitations[foundLimitationIndex];
          limitation.true = foundLimitation.IsTrue;
          if (limitation.Pleadable) {
            limitation.pled = foundLimitation.IsPled;
          }
        }
        if (limitation.Category === null) {
          return;
        }
        const category = limitation.Category.split(",")[0];
        if (!this.categories.includes(category) && category != null && category != "") {
          this.categories.push(category);
        }
        this.caseProbationLimitations.forEach((cpl) => {
          const foundLimitationIndex = this.ProbationLimitations.findIndex(
            (limitation) => limitation.Id === cpl.ProbationLimitationId
          );
          if (foundLimitationIndex > -1) {
            const foundLimitation = this.ProbationLimitations[foundLimitationIndex];

            foundLimitation.true = cpl.IsTrue;
            if (foundLimitation.Pleadable) {
              foundLimitation.pled = cpl.IsPled;
            }
          }
        });
      });
      const catArray = ["Prior", "Deadly-weapon", "GBI", "Sex", "Drug", "Large-taking", "Elderly"];
      const catArrayUC = catArray.map((cat) => cat.toUpperCase());

      this.categories.sort((a, b) => {
        return indexOf(catArrayUC, a) - indexOf(catArrayUC, b);
      });
      this.selectedCategory = this.categories[0];
    },
    emitLawText(limitation) {
      if (limitation?.LawText?.length > 0) {
        this.$emit("displayModalPopup", {
          header: `${limitation?.LegacyStatuteText} ${limitation?.Name}`,
          body: limitation?.LawText,
        });
      } else {
        this.$emit("displayModalPopup", {
          header: ``,
          body: ``,
        });
      }
      // this.$emit("displayModalPopup", {
      //   header: `${limitation?.LegacyStatuteText} ${limitation?.Name}`,
      //   body: limitation?.LawText,
      // });
    },
    emitLawTextFactor(factor) {
      this.$emit("displayModalPopup", {
        header: `${factor.StatuteNumber}`,
        body: factor.LawText,
      });
    },
    async loadProbationFactors() {
      this.probationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + "/api/probationFactors", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));
      this.probationFactors.forEach((pf) => {
        pf.IsTrue = null;
      });
      return this.probationFactors;
    },
    async loadCaseProbationFactors() {
      this.caseProbationFactors = await axios
        .get(process.env.VUE_APP_ENDPOINT + `/api/caseProbationFactors/byCase/${this.selectedCase.Id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));
      this.caseProbationFactors.forEach((cpf) => {
        this.probationFactors.find((pf) => pf.Id == cpf.ProbationFactorId).IsTrue = cpf.IsTrue;
      });
      return this.caseProbationFactors;
    },
    async createCaseProbationFactor(pf) {
      const createdCPF = await axios
        .post(
          process.env.VUE_APP_ENDPOINT + "/api/caseProbationFactors",
          {
            CaseId: this.selectedCase.Id,
            ProbationFactorId: pf.Id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user_token")}`,
            },
          }
        )
        .then((res) => res.data)
        .catch((e) => console.log(e));
      this.caseProbationFactors.push(createdCPF);
    },
    async deleteCaseProbationFactor(pf) {
      await axios
        .delete(process.env.VUE_APP_ENDPOINT + `/api/caseProbationFactors/${pf.Id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        })
        .then((res) => res.data)
        .catch((e) => console.log(e));
      const foundIndex = this.caseProbationFactors.findIndex((cpf) => cpf.Id == pf.ProbationFactorId);
      if (foundIndex > -1) {
        this.caseProbationFactors.splice(foundIndex, 1);
      }
    },
  },
  async mounted() {
    this.loading = true;
    // await this.loadCaseProbationLimitations();
    this.pleadCaseProbationLimitations();
    // await this.loadProbationFactors();
    // await this.loadCaseProbationFactors();
    // this.suggestProbationLimitationsToAdd();
    this.markProbationLimitations();
    this.loading = false;
    // console.log(this.probationFactors);
    // let factorRelations = [];
    // this.probationFactors.forEach((factor) => {
    //   if (factorRelations.includes(factor.RelatedFactorId)) {
    //     return;
    //   }
    //   factorRelations.push(factor.Relation);
    // });
    // Code to run when the component is mounted goes here
  },
};
</script>

<style scoped>
.ta-c {
  text-align: center;
}

.hi-z {
  z-index: 2000;
}

.btn-disabled {
  background-color: gray !important;
  color: black !important;
  cursor: not-allowed;
}

.main {
  width: 75vw;
}

@media (max-width: 768px) {
  .main {
    width: 90vw;
  }
}

/* Your component-specific styles go here */
</style>
